import { render, staticRenderFns } from "./ZyroPagination.vue?vue&type=template&id=1da49224&scoped=true&"
import script from "./ZyroPagination.vue?vue&type=script&lang=js&"
export * from "./ZyroPagination.vue?vue&type=script&lang=js&"
import style0 from "./ZyroPagination.vue?vue&type=style&index=0&id=1da49224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da49224",
  null
  
)

export default component.exports